
import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router';
import MyDoughnutChart from '../../Components/Charts/MyDoughnutChart';
import { CommonContext } from '../../App';
import { useTranslation } from 'react-i18next';
import Navbar from '../../Components/Navbar/Navbar';
import { FaArrowTrendDown, FaArrowTrendUp } from "react-icons/fa6";
import { FaArrowRight, FaCalendarCheck } from 'react-icons/fa';
import { AiOutlineTransaction } from "react-icons/ai";
import { GrTransaction } from "react-icons/gr";
import MyPieChart from '../../Components/Charts/MyPieChart';
import toast from 'react-hot-toast';
import api from '../../services/api';
import { BiAddToQueue, BiBookmarkAltPlus } from 'react-icons/bi';
import { useMemo } from 'react';

export default function DashBoardData() {
  const { t } = useTranslation();
  const { branchId, dateRange } = useContext(CommonContext);
  // console.log("branchId",branchId)

  const navigate = useNavigate();

  const today = new Date();
  const currentYear = today.getFullYear();
  const april = new Date(`${currentYear}-04-01`);
  const startYear = today >= april ? currentYear : currentYear - 1;

  const financeYearStr = `${startYear}-04-01`;
  const todayStr = today.toISOString().split("T")[0];

  // const [startDate, setStartDate] = useState(dateRange.startDate);
  // const [endDate, setEndDate] = useState(dateRange.endDate);
  const startDate = dateRange.startDate;
  const endDate = dateRange.endDate;
  const [salesBranches, setSalesBranches] = useState([]);
  const [purchaseBranches, setPurchaseBranches] = useState([]);
  const [paymentBranches, setPaymentBranches] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [saleswithType, setSaleswithType] = useState([]);
  const [purchasewithItem, setPurchasewithItem] = useState([]);
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalExpense, setTotalExpense] = useState(0);
  const [branchPL, setBranchPL] = useState([]);

  const [defaultDateRange] = useState({
    startDate: financeYearStr,
    endDate: todayStr,
  });

  const QuickAtion = [
    {
      title: t("receipt"),
      icon: BiBookmarkAltPlus,
      path: "/dashboard/receipt-transactions",
      backgroudColor: "bg-red-400"
    },
    {
      title: t("payment"),
      icon: GrTransaction,
      path: "/dashboard/payment-transactions",
      backgroudColor: "bg-blue-400"
    },
    {
      title: t("purchase"),
      icon: FaArrowTrendDown,
      path: "/dashboard/purchase-table",
      backgroudColor: "bg-purple-400"
    },
    {
      title: t("sales"),
      icon: FaArrowTrendUp,
      path: "/dashboard/sales-table",
      backgroudColor: "bg-green-400"
    },
    {
      title: t("journalEntry"),
      icon: AiOutlineTransaction,
      path: "/dashboard/journal-entry",
      backgroudColor: "bg-orange-400"
    },
    {
      title: t("dayBook"),
      icon: BiAddToQueue,
      path: "daily-reports",
      backgroudColor: "bg-slate-400"
    },
  ];




  const fetchData = async (startDate, endDate, branchId) => {
    try {
      const res = await api.get("dash/get-total", {
        params: { startDate, endDate, branchId },
      });

      if (!res?.data?.success) return;

      const data = res.data.summary || {};

      setSalesBranches(data.sales?.branches || []);
      setPurchaseBranches(data.purchase?.branches || []);
      setPaymentBranches(data.paymentAccounts?.branches || []);

      setSaleswithType(
        (data.sales?.branches || []).flatMap(b =>
          (b.quantityByTypeOfBricks || []).map(item => ({
            name: String(item.name || "").trim(),
            totalQuantity: Number(item.totalQuantity || 0),
            branchId: b.branchId,
            branchName: b.branchName,
          }))
        )
      );

      setPurchasewithItem(
        (data.purchase?.branches || []).flatMap(b =>
          (b.quantityByItems || []).map(item => ({
            name: String(item.name || "").trim(),
            totalQuantity: Number(item.totalQuantity || 0),
            branchId: b.branchId,
            branchName: b.branchName,
          }))
        )
      );
    } catch (error) {
      toast.error("Failed to load dashboard data");
      console.error(error);
    }
  };

  const fetchInventory = async (startDate, endDate, branchId) => {
    try {
      if (!branchId) return;
      const res = await api.get("inventory/get-all-item", {
        params: { branchId, startDate, endDate },
      });

      if (!res?.data?.success) return [];

      const finalArray = Array.isArray(res.data.data)
        ? res.data.data
        : res.data.data?.allData || [];

      setInventory(finalArray);
      return finalArray;
    } catch (error) {
      toast.error("Failed to fetch inventory");
      console.error(error);
      return [];
    }
  };

  const fetchDataPL = async (startDate, endDate, branchId) => {
    try {
      const res = await api.get("ledgers/get-trial-summary", {
        params: { startDate, endDate, branchId },
      });

      if (!res?.data?.success) return;

      const branchPL = [];
      let totalIncome = 0;
      let totalExpense = 0;

      res.data.data.forEach(branchBlock => {
        let income = 0;
        let expense = 0;

        (branchBlock.branchData || []).forEach(ledger => {
          const received = Number(ledger.totalReceived || 0);
          const paid = Number(ledger.totalPaid || 0);

          const debit = received > paid ? received - paid : 0;
          const credit = paid > received ? paid - received : 0;

          if (ledger.groupType === "Income") income += credit;
          if (ledger.groupType === "Expense") expense += debit;
        });

        branchPL.push({
          branchId: branchBlock.branchId,
          branchName: branchBlock.branchName,
          income,
          expense,
          profitLoss: income - expense,
        });

        totalIncome += income;
        totalExpense += expense;
      });

      setTotalIncome(totalIncome);
      setTotalExpense(totalExpense);
      setBranchPL(branchPL);
    } catch (error) {
      toast.error("Failed to load Profit & Loss");
      console.error(error);
    }
  };

  useEffect(() => {
    if (
      !branchId ||
      branchId === "undefined" ||
      branchId === "null" ||
      branchId === "" ||
      !startDate ||
      !endDate
    ) {
      return;
    }

    const loadData = async () => {
      const id = branchId;
      await Promise.all([
        fetchData(startDate, endDate, id),
        fetchInventory(startDate, endDate, id),
        fetchDataPL(startDate, endDate, id),
      ]);
    };

    loadData();
  }, [branchId, startDate, endDate]);

  const getCashBankByBranch = (branch) => {
    let cash = 0;
    let bank = 0;

    if (!branch?.ledgers) return { cash, bank };

    branch.ledgers.forEach((ledger) => {
      const amount = Number(ledger.closingBalance || 0); // 👈 use closing

      const name = ledger.ledgerName?.toLowerCase() || "";

      if (name.includes("cash")) {
        cash += amount;
      }

      if (
        name.includes("bank") ||
        name.includes("sbi") ||
        name.includes("hdfc") ||
        name.includes("cbi") ||
        name.includes("upi") ||
        name.includes("net")
      ) {
        bank += amount;
      }
    });

    return { cash, bank };
  };

  const allBranches = useMemo(() => {
    const branchMap = new Map();

    const addBranch = (id, name) => {
      if (!branchMap.has(id)) {
        branchMap.set(id, { branchId: id, branchName: name });
      }
    };

    salesBranches.forEach(b => addBranch(b.branchId, b.branchName));
    purchaseBranches.forEach(b => addBranch(b.branchId, b.branchName));
    paymentBranches.forEach(b => addBranch(b.branchId, b.branchName));
    branchPL.forEach(b => addBranch(b.branchId, b.branchName));

    return Array.from(branchMap.values());
  }, [salesBranches, purchaseBranches, paymentBranches, branchPL]);

  const getTotalForField = (branches, fieldName) =>
    (branches || []).reduce((sum, b) => sum + Number(b[fieldName] || 0), 0);

  const getTotalCashAllBranches = () =>
    (paymentBranches || []).reduce((sum, b) => sum + getCashBankByBranch(b).cash, 0);

  const getTotalBankAllBranches = () =>
    (paymentBranches || []).reduce((sum, b) => sum + getCashBankByBranch(b).bank, 0);
  const getBranchValue = (branchesArray, branchId, field) => {
    const branch = branchesArray.find(b => b.branchId === branchId);
    return branch ? Number(branch[field] || 0) : 0;
  };

  // 🔥 Common Amount Formatter Component
  const Amount = ({ value, className = "" }) => {
    const num = Number(value) || 0;

    return (
      <span className={`${num < 0 ? "text-red-600 font-medium" : ""} ${className}`}>
        {Math.abs(num).toLocaleString("en-IN")}
      </span>
    );
  };

  return (
    <div className='container-fluid pb-lg-5 pb-3'>
      <div className="row sticky top-0 z-10 pb-[0.5px] bg-theme-webBackground">
        <Navbar defaultDateRange={defaultDateRange} checkDate={false} />
      </div>

      <div className='row'>

        <div className="col-3">
          <div className='border bg-white rounded-3 text-gray-800 py-1 py-xl-2 h-full flex flex-col justify-around font-medium'>
            <div className="flex justify-between">
              <div className='text-sm px-2 pt-[2px] font-serif font-bold'>{t('cash')}(₹)</div>
              <div className='text-sm px-2 pt-[2px] font-bold'><Amount value={getTotalCashAllBranches()} /></div>
            </div>
            <div className='pb-3 pt-1 text-slate-500 px-2 text-start'>
              {allBranches.map((b) => {
                const paymentBranch = paymentBranches.find(pb => pb.branchId === b.branchId);
                const { cash } = paymentBranch ? getCashBankByBranch(paymentBranch) : { cash: 0 };

                return (
                  <div key={b.branchId} className={`flex justify-between ${allBranches.length > 1 && "border-b border-dashed"} text-sm`}>
                    <span className='pb-[2px]'>{b.branchName}</span>
                    <span><Amount value={cash} /></span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>


        <div className="col-3">
          <div className='border rounded-3 py-1 py-xl-2 bg-white text-gray-800 h-full flex flex-col justify-around font-medium'>
            <div className="flex justify-between">
              <div className='text-sm px-2 pt-[2px] font-serif font-bold'>{t('bank')}(₹)</div>
              <div className='text-sm px-2 pt-[2px] font-bold'><Amount value={getTotalBankAllBranches()} /></div>
            </div>
            <div className='pb-3 pt-2 text-start text-slate-500 px-2'>
              {allBranches.map((b) => {
                const paymentBranch = paymentBranches.find(pb => pb.branchId === b.branchId);
                const { bank } = paymentBranch ? getCashBankByBranch(paymentBranch) : { bank: 0 };

                return (
                  <div key={b.branchId} className={`flex justify-between ${allBranches.length > 1 && "border-b border-dashed"} text-sm`}>
                    <span className='pb-[2px]'>{b.branchName}</span>
                    <span><Amount value={bank} /></span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>


        <div className="col-3">
          <div className='border py-1 py-xl-2 bg-white rounded-3 text-gray-800 h-full flex flex-col justify-around font-medium'>
            <div className="flex justify-between">
              <div className='text-sm px-2 pt-[2px] font-serif font-bold'>{t('totalSales')}</div>
              <div className='text-sm px-2 pt-[2px] font-bold'>
                <Amount value={getTotalForField(salesBranches, "totalQuantity")} />
              </div>
            </div>
            <div className='pb-3 pt-2 text-slate-500 px-2'>
              {allBranches.map((b) => (
                <div key={b.branchId} className={`flex justify-between ${allBranches.length > 1 && "border-b border-dashed"} text-sm`}>
                  <span className='pb-[2px]'>{b.branchName}</span>
                  <span><Amount value={getBranchValue(salesBranches, b.branchId, "totalQuantity")} /></span>
                </div>
              ))}
            </div>
          </div>
        </div>


        <div className="col-3">
          <div className='border py-1 py-xl-2 bg-white rounded-3 text-gray-800 h-full flex flex-col justify-around font-medium'>
            <div className="flex justify-between">
              <div className='text-sm px-2 pt-[2px] font-serif font-bold'>{t('totalPurchase')}</div>
              <div className='text-sm px-2 pt-[2px] font-bold'>
                <Amount value={getTotalForField(purchaseBranches, "totalQuantity")} />
              </div>
            </div>
            <div className='pb-3 pt-2 text-slate-500 px-2'>
              {allBranches.map((b) => (
                <div key={b.branchId} className={`flex justify-between ${allBranches.length > 1 && "border-b border-dashed"} text-sm`}>
                  <span className='pb-[2px]'>{b.branchName}</span>
                  <span><Amount value={getBranchValue(purchaseBranches, b.branchId, "totalQuantity")} /></span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-5">
        {/* PROFIT / LOSS */}
        <div className="col-4 mb-4">
          <div className="p-3 border rounded text-sm h-full bg-[#ffffff] shadow-sm ">
            <div className='flex justify-between'>
              <div className='font-bold'>{t("currentMonth")}</div>
              <div>
                <FaCalendarCheck
                  className='text-gray-500 cursor-pointer'
                  title='Check Profit and Loss report'
                  onClick={() => navigate('/reports/profit-loss')}
                />
              </div>
            </div>

            {/* 🔥 MULTI BRANCH MODE */}
            {branchPL.length > 1 ? (
              <div className="mt-3 space-y-2">
                {branchPL.map(b => (
                  <div key={b.branchId} className=" text-sm font-medium">
                    <div>{b.branchName}</div>
                    <div className={`${b.profitLoss >= 0 ? "text-green-600" : "text-red-600"} flex justify-between border-b border-dashed `}>
                      <span className='pb-1' >
                        {b.profitLoss >= 0 ? t("netProfit") : t("netLoss")}
                      </span>
                      <span >
                        ₹ {Math.abs(b.profitLoss).toFixed(2)}
                      </span>
                    </div>
                  </div>

                ))}
              </div>
            ) : (
              /* 🔥 SINGLE BRANCH MODE (OLD UI) */
              <>
                <div className='flex my-3 justify-between font-medium'>
                  <div>{t("totalExpense")}</div>
                  <div className='text-theme-tabBg'>(₹) {totalExpense.toFixed(2)}</div>
                </div>

                <div className='flex my-3 justify-between font-medium'>
                  <div>{t("totalIncome")}</div>
                  <div className='text-theme-btnBg'>(₹) {totalIncome.toFixed(2)}</div>
                </div>

                <div className='flex my-3 justify-between border-t font-medium text-sm'>
                  <div>{totalIncome > totalExpense ? t("netProfit") : t("netLoss")}</div>
                  <div className={totalIncome > totalExpense ? "text-green-600" : "text-red-600"}>
                    (₹) {Math.abs(totalIncome - totalExpense).toFixed(2)}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>


        {/* QUICK ACTIONS */}
        <div className="col-8 mb-4">
          <div className="p-3 border rounded bg-white shadow-sm">
            <div className='row'>
              <div className='text-sm font-bold'>{t("actions")}</div>
              {QuickAtion.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div className="col-4 text-sm p-2" key={index}>
                    <div
                      className='border rounded hover:bg-gray-50 cursor-pointer p-3'
                      onClick={() => {
                        if (typeof branchId === "string" && branchId.includes(",")) {
                          toast.error(t("selectOnlyOneBranch"));
                          return;
                        }
                        navigate(item.path);
                      }}
                    >
                      <div className='flex justify-between align-middle'>
                        <div className='flex gap-2'>
                          <div className='flex flex-col justify-center'>
                            <div className={`${item.backgroudColor} flex h-8 w-8 rounded-1 text-theme-color`}>
                              <Icon className='h-full w-full p-2' />
                            </div>
                          </div>
                          <div className='font-bold text-sm mt-[6px]'>{item.title}</div>
                        </div>
                        <div className='flex flex-col justify-center text-gray-400'>
                          <FaArrowRight />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* SALES CHART */}
        <div className="col-4 p-2">
          <div className='px-2 mt-2 font-serif font-bold'>{t('sales')}</div>
          <div className="bg-white border rounded pb-3 flex justify-center overflow-hidden">
            <div className='relative w-full flex justify-center' style={{ height: 330 }}>
              <MyDoughnutChart dataSource={saleswithType} title="" />
            </div>
          </div>
        </div>

        {/* PURCHASE CHART */}
        <div className="col-4 p-2">
          <div className='px-2 mt-2 font-serif font-bold'>{t('purchase')}</div>
          <div className="bg-white border rounded pb-3 flex justify-center overflow-hidden">
            <div className='relative w-full flex justify-center' style={{ height: 330 }}>
              <MyDoughnutChart dataSource={purchasewithItem} title="" />
            </div>
          </div>
        </div>

        {/* STOCK CHART */}
        <div className="col-4 p-2">
          <div className='px-2 mt-2 font-serif font-bold'>{t('stock')}</div>
          <div className="bg-white border rounded pb-3 flex justify-center overflow-hidden">
            <div className='relative w-full flex justify-center' style={{ height: 330 }}>
              <MyPieChart dataSource={inventory} title="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}